import React, { Component } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, FormHelperText,
  Grid,
  IconButton,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, Checkbox, Tooltip
} from "@material-ui/core";
import AddBoxIcon from "@material-ui/icons/AddBox";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { CreateLeadOffer, DeleteLeadOffer, UpdateLeadOffer } from "./LeadsAction";
import { connect } from "react-redux";
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import locale from "antd/es/date-picker/locale/de_DE";
import moment from "moment";
import NumberFormat from "react-number-format";
import isEmpty from 'lodash.isempty';
import truncate from 'lodash/truncate';

const dateFormat = 'DD.MM.YYYY';

class LeadOffers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      LeadOfferSaveUpdateDialogOpen: false,
      LeadOfferDeleteDialogOpen: false,
      lead_offer_row: '',
      editMode: false,
      offerdate: '',
      paper: 0,
      mail: 0,
      fee: '',
      days: '',
      addcosts: '',
      addcostsinfo: '',
      decisiondate: '',
      decision: '',
      isOfferDateEmpty: false,
      isFeeEmpty: false,
      isDaysEmpty: false,
      lead_offers: []
    }
  }

  componentDidMount() {
    this.setState({
      lead_id: this.props.lead_id,
      updateMode: this.props.updateMode,
      lead_offers: this.props.existing_lead_offers,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.updated_lead_offers !== this.props.updated_lead_offers) {
      this.setState({ lead_offers: this.props.updated_lead_offers });
    }
  }

  createLeadOfferDialog = () => {
    this.setState({
      LeadOfferSaveUpdateDialogOpen: true
    });
  }

  saveLeadOfferDialog = () => {
    const { updateMode, lead_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision } = this.state;
    if (updateMode) {
      if (!isEmpty(offerdate) && !isEmpty(fee) && !isEmpty(days)) {
        this.props.CreateLeadOffer(lead_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision);
        this.setState({
          offerdate: '',
          paper: '',
          mail: '',
          fee: '',
          days: '',
          addcosts: '',
          addcostsinfo: '',
          decisiondate: '',
          decision: '',
          LeadOfferSaveUpdateDialogOpen: false,
        });
      } else {
        if (isEmpty(offerdate))
          this.setState({ isOfferDateEmpty: true })
        else if (isEmpty(fee))
          this.setState({ isFeeEmpty: true })
        else if (isEmpty(days))
          this.setState({ isDaysEmpty: true })
      }

    } else {
      if (!isEmpty(offerdate) && !isEmpty(fee) && !isEmpty(days)) {
        this.setState(state => ({
          lead_offers: [...state.lead_offers, {
            id: Date.now(),
            offerdate: offerdate,
            paper: paper,
            mail: mail,
            fee: fee,
            days: days,
            addcosts: addcosts,
            addcostsinfo: addcostsinfo,
            decisiondate: decisiondate,
            decision: decision
          }]
        }));

        this.props.offersClick({
          id: Date.now(),
          offerdate: offerdate,
          paper: paper,
          mail: mail,
          fee: fee,
          days: days,
          addcosts: addcosts,
          addcostsinfo: addcostsinfo,
          decisiondate: decisiondate,
          decision: decision
        });

        this.setState({
          offerdate: '',
          paper: '',
          mail: '',
          fee: '',
          days: '',
          addcosts: '',
          addcostsinfo: '',
          decisiondate: '',
          decision: '',
          LeadOfferSaveUpdateDialogOpen: false,
        });
      } else {
        if (isEmpty(offerdate))
          this.setState({ isOfferDateEmpty: true })
        else if (isEmpty(fee))
          this.setState({ isFeeEmpty: true })
        else if (isEmpty(days))
          this.setState({ isDaysEmpty: true })
      }
    }
  }

  updateLeadOfferDialog = () => {
    const { lead_id, offer_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision } = this.state;
    this.props.UpdateLeadOffer(lead_id, offer_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision);
    this.setState({
      offerdate: '',
      paper: '',
      mail: '',
      fee: '',
      days: '',
      addcosts: '',
      addcostsinfo: '',
      decisiondate: '',
      decision: '',
      LeadOfferSaveUpdateDialogOpen: false,
      editMode: false
    });
  }

  addLeadOfferDialog = () => {
    const { updateMode, editMode, newFieldsEditMode } = this.state;
    if (updateMode && editMode) {
      this.updateLeadOfferDialog();
    } else if (newFieldsEditMode) {
      const { lead_id, lead_offers, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision } = this.state;
      const new_offer = {
        id: lead_id,
        offerdate,
        paper,
        mail,
        fee,
        days,
        addcosts,
        addcostsinfo,
        decisiondate,
        decision,
      };
      const updated_lead_offers = lead_offers.map((lead) => lead.id === lead_id ? new_offer : lead);
      this.setState({
        lead_offers: updated_lead_offers,
        offerdate: '',
        paper: '',
        mail: '',
        fee: '',
        days: '',
        addcosts: '',
        addcostsinfo: '',
        decisiondate: '',
        decision: '',
        newFieldsEditMode: false,
        LeadOfferSaveUpdateDialogOpen: false
      });
    } else {
      this.saveLeadOfferDialog();
    }
  }

  handleUpdateFields = (lead_offer) => {
    const { updateMode } = this.state;
    if (updateMode) {
      this.setState({
        offer_id: lead_offer.id,
        offerdate: lead_offer.offerdate,
        paper: lead_offer.paper,
        mail: lead_offer.mail,
        fee: lead_offer.fee,
        days: lead_offer.days,
        addcosts: lead_offer.addcosts,
        addcostsinfo: lead_offer.addcostsinfo,
        decisiondate: lead_offer.decisiondate === null ? '' : lead_offer.decisiondate,
        decision: lead_offer.decision,
        LeadOfferSaveUpdateDialogOpen: true,
        editMode: true
      });
    } else {
      this.setState(state => ({
        lead_id: lead_offer.id,
        offerdate: lead_offer.offerdate,
        paper: lead_offer.paper,
        mail: lead_offer.mail,
        fee: lead_offer.fee,
        days: lead_offer.days,
        addcosts: lead_offer.addcosts,
        addcostsinfo: lead_offer.addcostsinfo,
        decisiondate: lead_offer.decisiondate,
        decision: lead_offer.decision,
        LeadOfferSaveUpdateDialogOpen: true,
        newFieldsEditMode: true,
      }));
    }
  }

  launchDeleteLeadOfferDialog = (lead_offer) => {
    this.setState({ LeadOfferDeleteDialogOpen: true, lead_offer_row: lead_offer });
  }

  handleRemoveFields = () => {
    const { updateMode, lead_offer_row } = this.state;
    if (updateMode) {
      this.props.DeleteLeadOffer(lead_offer_row.lead_id, lead_offer_row.id);
    } else {
      this.setState(prevState => ({ lead_offers: prevState.lead_offers.filter(lead_offer_rec => lead_offer_rec !== lead_offer_row) }));
    }
    this.setState({ LeadOfferDeleteDialogOpen: false });
  };

  closeDeleteLeadOfferDialog = () => {
    this.setState({ LeadOfferDeleteDialogOpen: false })
  }

  closeLeadOfferDialog = () => {
    this.setState({
      offerdate: '',
      paper: '',
      mail: '',
      fee: '',
      days: '',
      addcosts: '',
      addcostsinfo: '',
      decisiondate: '',
      decision: '',
      isOfferDateEmpty: false,
      isPaperEmpty: false,
      isFeeEmpty: false,
      isDaysEmpty: false,
      isMailValid: false,
      LeadOfferSaveUpdateDialogOpen: false,
    });
  }

  handlePaperField = (e) => {
    let newPaper
    if (e.target.checked === true) {
      newPaper = 1
    } else {
      newPaper = 0
    }
    this.setState({ paper: newPaper })
  }

  handleMailField = (e) => {
    let newMail
    if (e.target.checked === true) {
      newMail = 1
    } else {
      newMail = 0
    }
    this.setState({ mail: newMail })
  }

  getFormattedNumber(value) {
    return <NumberFormat
      value={value}
      displayType={'text'}
      decimalSeparator={","}
      decimalScale={0}
      thousandSeparator={"."}
      isNumericString={true}
    />
  }

  checkDateFormat = (date) => {
    if (moment(date, 'YYYY-MM-DD', true).isValid()) {
      return moment(date).format("DD.MM.YYYY")
    } else {
      return date
    }
  }

  render() {

    const { LeadOfferSaveUpdateDialogOpen, LeadOfferDeleteDialogOpen, offerdate, paper, mail, fee, days, addcosts,
      addcostsinfo, decisiondate, decision, lead_offers, isOfferDateEmpty, isFeeEmpty, isDaysEmpty } = this.state;
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return (
      <React.Fragment>
        <Grid item xs={2} style={{ lineHeight: '1.5', margin: '10px 0' }}>
          <div className="partner-div partner-div-1">
            Angebote
                        {Number(access_rights.leads) === 2 ?
              <IconButton>
                <AddBoxIcon style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => { this.createLeadOfferDialog() }} />
              </IconButton> : ''}
          </div>
        </Grid>

        <TableContainer component={Paper} className="lead_plan_offer">
          <Table size="small" aria-label="dense table">
            <TableHead>
              <TableRow>
                {Number(access_rights.leads) === 2 ? <TableCell align="right" colSpan={2} width='7.5%'></TableCell> : ''}
                <TableCell align="center" width='10%'>Abgabedatum</TableCell>
                <TableCell align="center" width='10%'>Papier</TableCell>
                <TableCell align="center" width='10%'>Mail</TableCell>
                <TableCell align="center" width='10%'>Honorar</TableCell>
                <TableCell align="center" width='10%'>Tage</TableCell>
                <TableCell align="center" width='10%'>NK</TableCell>
                <TableCell align="center" width='10%'>NK Info</TableCell>
                <TableCell align="center" width='10%'>Entsch.Datum</TableCell>
                <TableCell className="min100" align="center" width='40%' >Entscheidung</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                lead_offers.map((lead_offer, index) => (
                  <TableRow key={`mi-${index}`} className={index % 2 == 0 ? 'grey_row' : ''}>
                    {Number(access_rights.leads) === 2 ?
                      <TableCell align="right" colSpan={2} className={'no_border'} width='7.5%'>
                        <IconButton>
                          <EditIcon onClick={() => this.handleUpdateFields(lead_offer)} />
                        </IconButton>
                        <IconButton>
                          <DeleteIcon onClick={() => this.launchDeleteLeadOfferDialog(lead_offer)} />
                        </IconButton>
                      </TableCell> : ''}
                    <TableCell align="center" width='10%'>{this.checkDateFormat(lead_offer.offerdate)}</TableCell>
                    <TableCell align="center" width='10%'>{lead_offer.paper ? 'Ja' : 'Nein'}</TableCell>
                    <TableCell align="center" width='10%'>{lead_offer.mail ? 'Ja' : 'Nein'}</TableCell>
                    <TableCell align="right" width='10%'>{this.getFormattedNumber(lead_offer.fee)}</TableCell>
                    <TableCell align="right" width='10%'>{lead_offer.days.toString().replace(/\./g, ',')}</TableCell>
                    <TableCell align="right" width='10%'>{this.getFormattedNumber(lead_offer.addcosts)}</TableCell>
                    <TableCell align="left" width='10%'>
                      <Tooltip title={lead_offer.addcostsinfo}>
                        <span align="left">{truncate(lead_offer.addcostsinfo, { 'length': 10, 'separator': ' ' })}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center" width='10%'>{this.checkDateFormat(lead_offer.decisiondate)}</TableCell>
                    <TableCell align="left" width='30%'>
                      <Tooltip title={lead_offer.decision}>
                        <span align="left">{truncate(lead_offer.decision, { 'length': 25, 'separator': ' ' })}</span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={LeadOfferSaveUpdateDialogOpen} maxWidth="md">
          <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>Angebote</DialogTitle>
          <DialogContent className="p-60">
            <Grid container spacing={1} justify="center">
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Abgabedatum
                            </Grid>
              <Grid item xs={10}>
                <DatePicker
                  locale={locale}
                  fullWidth
                  required
                  size="small"
                  value={offerdate === '' ? '' : moment(offerdate)}
                  format={dateFormat}
                  placeholder="DD.MM.YYYY"
                  allowClear={false}
                  bordered={false}
                  onChange={(e) => {
                    let date = moment(e);
                    this.setState({ offerdate: date, isOfferDateEmpty: false })
                  }}
                />
                <FormHelperText error>{isOfferDateEmpty && isOfferDateEmpty ? 'Bitte geben Sie das Angebotsdatum ein' : ''}</FormHelperText>
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Papier
                            </Grid>
              <Grid item xs={10}>
                <Checkbox
                  checked={paper === 1 ? true : false}
                  color="primary"
                  onChange={(e) => this.handlePaperField(e)}
                />
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Mail
                            </Grid>
              <Grid item xs={10}>
                <Checkbox
                  checked={mail === 1 ? true : false}
                  color="primary"
                  onChange={(e) => this.handleMailField(e)}
                />
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Honorar
                            </Grid>
              <Grid item xs={10}>
                <NumberFormat
                  customInput={TextField} required={true} fullWidth
                  inputProps={{ maxLength: 10 }} size="small" variant="outlined"
                  value={fee === '' ? 0 : Number(fee)}
                  decimalSeparator={","} decimalScale={0} allowNegative={false} thousandSeparator={"."}
                  onValueChange={(values) => this.setState({
                    fee: values.value,
                    isFeeEmpty: false
                  })}
                />
                <FormHelperText error>{isFeeEmpty && isFeeEmpty ? 'BItte geben Sie das Honorar ein' : ''}</FormHelperText>
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Tage
                            </Grid>
              <Grid item xs={10}>
                <NumberFormat
                  customInput={TextField} required={true} fullWidth
                  inputProps={{ maxLength: 5 }} size="small" variant="outlined"
                  value={days === '' ? 0 : Number(days)}
                  decimalSeparator="," decimalScale="1" allowNegative={false}
                  fixedDecimalScale={true} allowNegative={false}
                  onValueChange={(values) => this.setState({
                    days: values.value,
                    isDaysEmpty: false
                  })}
                />
                <FormHelperText error>{isDaysEmpty && isDaysEmpty ? 'Bitte geben Sie Tage ein' : ''}</FormHelperText>
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                NK
                            </Grid>
              <Grid item xs={10}>
                <NumberFormat
                  customInput={TextField} required={true} fullWidth
                  inputProps={{ maxLength: 10 }} size="small" variant="outlined"
                  value={addcosts === '' ? 0 : Number(addcosts)}
                  decimalSeparator={","} decimalScale={0} allowNegative={false} thousandSeparator={"."}
                  onValueChange={(values) => this.setState({
                    addcosts: values.value
                  })}
                />
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                NK Info
                            </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={addcostsinfo}
                  onChange={(e) => this.setState({ addcostsinfo: e.target.value })}
                  variant="outlined" />
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Entscheidungsdatum
                            </Grid>
              <Grid item xs={10}>
                <DatePicker
                  locale={locale}
                  fullWidth
                  required
                  size="small"
                  value={decisiondate === '' ? '' : moment(decisiondate)}
                  format={dateFormat}
                  placeholder="DD.MM.YYYY"
                  allowClear={false}
                  bordered={false}
                  onChange={(e) => {
                    let date = moment(e);
                    this.setState({ decisiondate: date })
                  }}
                />
              </Grid>
              <Grid item xs={2} style={{ lineHeight: '2.5' }}>
                Entscheidung
                            </Grid>
              <Grid item xs={10}>
                <TextField required fullWidth size="small" value={decision}
                  onChange={(e) => this.setState({ decision: e.target.value })}
                  variant="outlined" />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button variant="outlined" className="m-10" onClick={this.addLeadOfferDialog}
              color="primary">
              Speichern
                        </Button>
            <Button variant="outlined" className="m-10" onClick={this.closeLeadOfferDialog}
              color="secondary">
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={LeadOfferDeleteDialogOpen}>
          <DialogTitle>Angebote Löschen</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bist du sicher?
                        </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleRemoveFields} variant="outlined" size="small" color="primary"
              autoFocus>
              Bestätigen
                        </Button>
            <Button onClick={this.closeDeleteLeadOfferDialog} variant="outlined" color="secondary"
              size='small'>
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ leads }) => {
  return {
    isloading: leads.loading,
    updated_lead_offers: leads.lead_offers
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    CreateLeadOffer: (lead_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision) => dispatch(CreateLeadOffer(lead_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision)),
    UpdateLeadOffer: (lead_id, offer_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision) => dispatch(UpdateLeadOffer(lead_id, offer_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision)),
    DeleteLeadOffer: (lead_id, lead_offer_id) => dispatch(DeleteLeadOffer(lead_id, lead_offer_id))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadOffers);